<template>
    <div class="buttongroup">
        <div class="buttons">
            <button v-if="singleChat.status === 'open'" :disabled="choosenChats.length > 1"
                    type="button" class="btn btn-xs btn-default"
                    v-on:click.stop="selfAssign">Mir zuweisen
            </button>
            <button v-if="singleChat.status === 'closed'" :disabled="choosenChats.length > 1"
                    type="button" class="btn btn-xs btn-default"
                    v-on:click.stop="selfAssign">Erneut öffnen
            </button>
            <button v-if="singleChat.status === 'processed' && singleChat.userId !== userId" :disabled="choosenChats.length > 1"
                    type="button" class="btn btn-xs btn-default button-warning"
                    v-on:click.stop="selfAssign">Chat übernehmen
            </button>
            <button v-if="singleChat.status === 'open'" :disabled="choosenChats.length > 1"
                    type="button" class="btn btn-xs button-green"
                    v-on:click="handleGroupoverlay">Einer Gruppe zuweisen
            </button>
            <button v-if="!isWatched && singleChat.userId !== userId" :disabled="choosenChats.length > 1"
                    v-on:click.stop="readonly(true)" type="button" class="btn btn-xs button-green">
                <i class="fa fa-eye" aria-hidden="true"></i>
                beobachten (nur lesen)
            </button>
            <button v-if="isWatched" :disabled="choosenChats.length > 1"
                    v-on:click.stop="readonly(false)" type="button" class="btn btn-xs button-grey">
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
                nicht mehr beobachten
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Buttongroup',
        props: ['singleChat','choosenChats','isWatched','userId'],
        components: {},
        data() {
            return {
            }
        },
        methods: {
            readonly: function (state) {
                if (state) {
                    this.$emit('readonly')
                } else {
                    this.$emit('unset-readonly')
                }
            },
            selfAssign: function () {
                this.$emit('selfassign')
            },
            handleGroupoverlay: function () {
                    this.$emit('groupoverlay')
            }
        },
    }
</script>
<style lang="scss" scoped>
    .buttongroup {
        .buttons {
            display: flex;
            flex-wrap: wrap;
            button {
                flex: 1 0 auto;
                margin: 0 5px 5px 0;

                &.button-grey {
                    background-color: #ebebeb;
                    background-color: #000;
                    color: #fff;
                }
                &.button-green {
                    background-color: #42B886;
                    color: #fff;
                }
                &.button-warning {
                  background-color: #b84242;
                  color: #fff;
                }
            }
        }
    }
</style>
